import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { loadAdSense, ADSENSE_CLIENT } from "../lib/adsense";

export function AdSenseLoader() {
  useEffect(() => {
    loadAdSense().catch(() => {});
  }, []);
  return null;
}

export function AdSlot({ slot, name, className = "" }) {
  const insRef = useRef(null);
  const { key: locationKey } = useLocation();

  useEffect(() => {
    if (!slot || !ADSENSE_CLIENT) return undefined;
    let cancelled = false;
    loadAdSense()
      .then(() => {
        const el = insRef.current;
        if (cancelled || !el || el.getAttribute("data-adsbygoogle-status")) return;
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slot, locationKey]);

  if (!slot || !ADSENSE_CLIENT) return null;

  return (
    <div className={`ad-slot w-full min-w-0 ${className}`} data-testid={`ad-slot-${name}`}>
      <p className="mb-1.5 text-[10px] font-bold uppercase tracking-wider text-ink-soft/60">Advertisement</p>
      <ins
        key={`${slot}-${locationKey}`}
        ref={insRef}
        className="adsbygoogle block w-full"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
